var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.813a9.188 9.188 0 10.001 18.376A9.188 9.188 0 0010.5 1.812zM14.468 8l-4.319 5.988a.652.652 0 01-1.06 0l-2.557-3.544a.165.165 0 01.133-.26h.962c.209 0 .408.1.531.273l1.46 2.026 3.224-4.471a.656.656 0 01.531-.273h.962c.133 0 .211.152.133.26z",
    fill: "#52C41A"
  })));
}

export default __webpack_public_path__ + "./fonts/check-circle.25e960aa70432bb6497bf6a4568af685.svg";
export { SvgCheckCircle as ReactComponent };